export default function Mail({ color = "#3CBFFF" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      style={{ color }}
    >
      <path
        d="M28.555 11.1675L16.555 3.16754C16.3907 3.0579 16.1975 2.99939 16 2.99939C15.8025 2.99939 15.6093 3.0579 15.445 3.16754L3.445 11.1675C3.30801 11.2589 3.19572 11.3827 3.11809 11.528C3.04046 11.6732 2.99989 11.8354 3 12V25C3 25.5305 3.21071 26.0392 3.58579 26.4143C3.96086 26.7893 4.46957 27 5 27H27C27.5304 27 28.0391 26.7893 28.4142 26.4143C28.7893 26.0392 29 25.5305 29 25V12C29.0001 11.8354 28.9595 11.6732 28.8819 11.528C28.8043 11.3827 28.692 11.2589 28.555 11.1675ZM12.09 19L5 24V13.9413L12.09 19ZM14.1362 20H17.8638L24.9425 25H7.0575L14.1362 20ZM19.91 19L27 13.9413V24L19.91 19Z"
        fill="currentColor"
      />
    </svg>
  );
}
